import { type ComponentProps } from "react";

import { cn } from "@/lib/utils";

const Input = ({ className, type, ref, ...props }: ComponentProps<"input">) => {
  return (
    <input
      type={type}
      className={cn(
        `
          flex h-9 w-full rounded-md border border-input bg-transparent px-3
          py-1 text-base transition-colors
          file:border-0 file:bg-transparent file:text-sm file:font-medium
          file:text-foreground
          placeholder:text-foreground/70
          focus-visible:ring-1 focus-visible:ring-ring
          focus-visible:outline-none
          disabled:cursor-not-allowed disabled:opacity-50
          md:text-sm
        `,
        className,
      )}
      ref={ref}
      {...props}
    />
  );
};
Input.displayName = "Input";

export { Input };
